// Rohe Farbdefinitionen - Grundfarben
export const color = {
    brand: {
        one: "#167F58",
        two: "#04A368",
        text: "#28322E",
        background: "#FFFFFF",
        gray: "#E0E0E0",
    },
    green: {
        light: "#F0FFF1",
        dark: "#355C3F",
    },
    brown: {
        light: "#f9f6ed",
        dark: "#d8cca7",
    },
    gray: {
        main: "#e0e0e0",
        light: "#ebebeb",
    },
    black: {
        main: "#000000",
    },
    white: {
        main: "#ffffff",
    },
    blue: {
        main: "#1976D2",
    },
    red: {
        light: "#FFEBEE",
        dark: "#C62828",
    },
    orange: {
        light: "#FFE0B2",
        dark: "#E65100",
    },
};

// Größenspezifische Farben
export const sizeColors = {
    S: "#BB7E5D",
    M: "#167F58",
    L: "#28322E",
};
